"use client";

import { Box, SxProps, Theme } from "@mui/material";
import NextLink from "next/link";
import { ElementType, ReactNode } from "react";

export default function BroadsheetLink({
  href,
  children,
  external = false,
  component,
  sx,
  ...rest
}: {
  href: string;
  children: ReactNode;
  external?: boolean;
  component?: ElementType;
  sx?: SxProps<Theme>;
  id?: string;
  "aria-label"?: string;
  "aria-current"?: "page" | undefined;
}) {
  if (external) {
    return (
      <Box
        component={component ?? "a"}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        sx={sx}
        {...rest}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box component={NextLink} href={href} sx={sx} {...rest}>
      {children}
    </Box>
  );
}
